var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ins',{ref:"root",staticClass:"adsbygoogle",class:_vm.$attrs.class,style:(_vm.$attrs.style || _vm.defaultStyle),attrs:{"data-ad-client":_vm.normClient,"data-ad-slot":_vm.normSlot,"data-ad-format":_vm.normFormat,"data-full-width-responsive":_vm.normFullResp}}),(_vm.empty)?_vm._t("fallback"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }